import { render, staticRenderFns } from "./PageServicio.vue?vue&type=template&id=01b2e792&"
import script from "./PageServicio.vue?vue&type=script&lang=js&"
export * from "./PageServicio.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/silo.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports